<template>
  <v-container>
    <v-card outlined>
      <v-card-title>
        <v-flex>
          <v-layout>
            <v-flex xs4>
              <!-- <div class="subtitle-2 mb-1">Select Region</div> -->
              <v-select
                outlined
                dense
                hide-details
                return-object
                :items="regions"
                v-model="selectedRegion"
                item-text="name"
                placeholder="Select Region"
                @change="selectRegion"
              >
              </v-select>
            </v-flex>

            <v-flex text-right>
              <v-btn
                @click="openNewAnnouncementDialog"
                depressed
                color="primary"
              >
                Create New Announcement
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs4>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="announcements"
        :items-per-page="30"
        class="elevation-0"
        :search="search"
        no-data-text="No data available, Select a region to start"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small class="mr-2" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
          <v-icon small @click="copyItem(item)"> mdi-content-copy </v-icon>
        </template>
        <template v-slot:item.scheduledAt="{ item }">
          <div>
            {{ iMoment(item.scheduledAt) }}
          </div>
        </template>
        <!-- <template v-slot:item.region="{ item }">
          <div>
            {{ item.region.name }}
          </div>
        </template> -->
        <template v-slot:item.createdAt="{ item }">
          <div>
            {{ iMoment(item.createdAt) }}
          </div>
        </template>
      </v-data-table>
    </v-card>
    <new-announcement-dialog
      :selectedRegion="selectedRegion"
      :collection="collection"
      ref="newAnnouncementDialog"
    />
    <edit-announcement-dialog
      :selectedRegion="selectedRegion"
      :announcementDetail="editedItem"
      :collection="collection"
      ref="editAnnouncementDialog"
    />
    <v-dialog v-model="dialogDelete" width="300">
      <v-card>
        <v-card-title>Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            class="text-none subtitle-2"
            @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-none subtitle-2"
            text
            @click="deleteItemConfirm"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import NewAnnouncementDialog from "../components/NewAnnouncementDialog";
import EditAnnouncementDialog from "../components/EditAnnouncementDialog.vue";
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  components: { NewAnnouncementDialog, EditAnnouncementDialog },
  data() {
    return {
      selectedRegion: {},
      collection: "pipeline",

      search: "",
      dialogDelete: false,
      itemToDelete: {
        scheduledAt: "",
        state: "",
        data: {
          backgroundColor: "",
          expiresAt: "",
          icon: {
            name: "",
            type: "",
          },
          location: {
            latitude: "",
            longitude: "",
          },
          navigate: {
            action: "",
            backgroundColor: "",
            textColor: "",
            to: "",
          },
          placement: "",

          subtitle: "",
          textColor: "",
          title: "",
        },
      },
      headers: [
        {
          text: "Title",
          align: "start",
          sortable: true,
          value: "data.title",
        },
        // { text: "Font Family", value: "fontFamily" },
        // { text: "Font Name", value: "fontName" },

        { text: "Scheduled At", value: "scheduledAt" },
        { text: "Placement", value: "data.placement" },
        { text: "State", value: "state" },
        { text: "Created At", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      editedItem: {
        scheduledAt: "",
        state: "",
        data: {
          backgroundColor: "",
          expiresAt: "",
          icon: {
            name: "",
            type: "",
          },
          location: {
            latitude: "",
            longitude: "",
          },
          navigate: {
            action: "",
            backgroundColor: "",
            textColor: "",
            to: "",
          },
          placement: "",

          subtitle: "",
          textColor: "",
          title: "",
        },
      },
      editedIndex: -1,
      defaultItem: {
        scheduledAt: "",
        state: "",
        data: {
          backgroundColor: "",
          expiresAt: "",
          icon: {
            name: "",
            type: "",
          },
          location: {
            latitude: "",
            longitude: "",
          },
          navigate: {
            action: "",
            backgroundColor: "",
            textColor: "",
            to: "",
          },
          placement: "",

          subtitle: "",
          textColor: "",
          title: "",
        },
      },
    };
  },
  computed: {
    ...mapState("$_content", ["announcements"]),
    ...mapState("$_home", ["regions"]),
  },
  created() {
    // if (this.announcements.length === 0) {
    //   this.getAnnouncements({
    //     type: "announcement",
    //     collection: "pipeline2",

    //     mutation: "updateAnnouncements",
    //   });
    // }
    if (this.regions.length === 0) {
      this.getRegions({ collection: "regions", mutation: "updateRegions" });
    }
  },
  methods: {
    ...mapActions({
      getAnnouncements: "$_content/getContent",
      getAnnouncementsByRegion: "$_content/getContentByRegion",
      deleteAnnouncement: "$_content/deleteContent",
      getRegions: "$_home/getContent",
    }),
    selectRegion() {
      // console.log("selectedRegion: ", this.selectedRegion);

      this.getAnnouncementsByRegion({
        type: "announcement",
        collection: this.collection,
        mutation: "updateAnnouncements",
        region: this.selectedRegion,
      });
    },

    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp.seconds * 1000;
        return moment(temp).format("lll");
      } else {
        return 0;
      }
    },
    openNewAnnouncementDialog() {
      this.$refs.newAnnouncementDialog.toggleDialog();
    },
    editItem(item) {
      this.editedIndex = this.announcements.indexOf(item);
      this.editedItem = {};
      this.editedItem = Object.assign({}, this.announcements[this.editedIndex]);

      // console.log("Edited Item: ", this.editedItem);

      this.$refs.editAnnouncementDialog.toggleDialog(this.editedItem);
    },
    searchArr(latitude, longitude, myArray) {
      for (var i = 0; i < myArray.length; i++) {
        if (
          myArray[i].latitude === latitude &&
          myArray[i].longitude === longitude
        ) {
          return myArray[i].name;
        }
      }
    },
    copyItem(item) {
      this.editedIndex = this.announcements.indexOf(item);
      this.editedItem = {};
      this.editedItem = Object.assign({}, this.announcements[this.editedIndex]);

      // console.log("Edited Item: ", this.editedItem);

      this.$refs.editAnnouncementDialog.toggleDialog(this.editedItem, "copy");
    },
    deleteItem(item) {
      this.editedIndex = this.announcements.indexOf(item);
      this.itemToDelete = Object.assign(
        {},
        this.announcements[this.editedIndex]
      );
      this.itemToDelete.state = "deleted";
      this.dialogDelete = true;

      // console.log(item);
    },
    deleteItemConfirm() {
      // console.log("Deleting Item: ", this.itemToDelete);

      this.deleteAnnouncement({
        details: this.itemToDelete,
        collection: this.collection,
        type: "Announcement",
      }).then(() => {
        this.dialogDelete = false;
        this.getAnnouncementsByRegion({
          type: "announcement",
          collection: this.collection,
          mutation: "updateAnnouncements",
          region: this.selectedRegion,
        });
      });
    },
  },
};
</script>

<style>
</style>